

function isEmpty(value: string | number) {
    return value === null || value === "";
}

export const stringUtils = {
    isEmpty
}
